/* !!! DO NOT EDIT !!! */ /* This file has been generated by the token pipeline */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "generateColorTokens", {
    enumerable: true,
    get: function() {
        return generateColorTokens;
    }
});
const _colors = require("../global/colors");
const generateColorTokens = ()=>({
        colorNeutralForeground1: _colors.hcCanvasText,
        colorNeutralForeground1Hover: _colors.hcHighlightText,
        colorNeutralForeground1Pressed: _colors.hcHighlightText,
        colorNeutralForeground1Selected: _colors.hcHighlightText,
        colorNeutralForeground2: _colors.hcCanvasText,
        colorNeutralForeground2Hover: _colors.hcHighlightText,
        colorNeutralForeground2Pressed: _colors.hcHighlightText,
        colorNeutralForeground2Selected: _colors.hcHighlightText,
        colorNeutralForeground2BrandHover: _colors.hcHighlightText,
        colorNeutralForeground2BrandPressed: _colors.hcHighlightText,
        colorNeutralForeground2BrandSelected: _colors.hcHighlightText,
        colorNeutralForeground3: _colors.hcCanvasText,
        colorNeutralForeground3Hover: _colors.hcHighlightText,
        colorNeutralForeground3Pressed: _colors.hcHighlightText,
        colorNeutralForeground3Selected: _colors.hcHighlightText,
        colorNeutralForeground3BrandHover: _colors.hcHighlightText,
        colorNeutralForeground3BrandPressed: _colors.hcHighlightText,
        colorNeutralForeground3BrandSelected: _colors.hcHighlightText,
        colorNeutralForeground4: _colors.hcCanvasText,
        colorNeutralForegroundDisabled: _colors.hcDisabled,
        colorNeutralForegroundInvertedDisabled: _colors.hcDisabled,
        colorBrandForegroundLink: _colors.hcHyperlink,
        colorBrandForegroundLinkHover: _colors.hcHyperlink,
        colorBrandForegroundLinkPressed: _colors.hcHyperlink,
        colorBrandForegroundLinkSelected: _colors.hcHyperlink,
        colorNeutralForeground2Link: _colors.hcHyperlink,
        colorNeutralForeground2LinkHover: _colors.hcHyperlink,
        colorNeutralForeground2LinkPressed: _colors.hcHyperlink,
        colorNeutralForeground2LinkSelected: _colors.hcHyperlink,
        colorCompoundBrandForeground1: _colors.hcHighlight,
        colorCompoundBrandForeground1Hover: _colors.hcHighlight,
        colorCompoundBrandForeground1Pressed: _colors.hcHighlight,
        colorBrandForeground1: _colors.hcCanvasText,
        colorBrandForeground2: _colors.hcCanvasText,
        colorBrandForeground2Hover: _colors.hcCanvasText,
        colorBrandForeground2Pressed: _colors.hcCanvasText,
        colorNeutralForeground1Static: _colors.hcCanvas,
        colorNeutralForegroundStaticInverted: _colors.hcCanvasText,
        colorNeutralForegroundInverted: _colors.hcHighlightText,
        colorNeutralForegroundInvertedHover: _colors.hcHighlightText,
        colorNeutralForegroundInvertedPressed: _colors.hcHighlightText,
        colorNeutralForegroundInvertedSelected: _colors.hcHighlightText,
        colorNeutralForegroundInverted2: _colors.hcCanvasText,
        colorNeutralForegroundOnBrand: _colors.hcButtonText,
        colorNeutralForegroundInvertedLink: _colors.hcHyperlink,
        colorNeutralForegroundInvertedLinkHover: _colors.hcHyperlink,
        colorNeutralForegroundInvertedLinkPressed: _colors.hcHyperlink,
        colorNeutralForegroundInvertedLinkSelected: _colors.hcHyperlink,
        colorBrandForegroundInverted: _colors.hcCanvasText,
        colorBrandForegroundInvertedHover: _colors.hcHighlightText,
        colorBrandForegroundInvertedPressed: _colors.hcHighlightText,
        colorBrandForegroundOnLight: _colors.hcButtonText,
        colorBrandForegroundOnLightHover: _colors.hcHighlightText,
        colorBrandForegroundOnLightPressed: _colors.hcHighlightText,
        colorBrandForegroundOnLightSelected: _colors.hcHighlightText,
        colorNeutralBackground1: _colors.hcCanvas,
        colorNeutralBackground1Hover: _colors.hcHighlight,
        colorNeutralBackground1Pressed: _colors.hcHighlight,
        colorNeutralBackground1Selected: _colors.hcHighlight,
        colorNeutralBackground2: _colors.hcCanvas,
        colorNeutralBackground2Hover: _colors.hcHighlight,
        colorNeutralBackground2Pressed: _colors.hcHighlight,
        colorNeutralBackground2Selected: _colors.hcHighlight,
        colorNeutralBackground3: _colors.hcCanvas,
        colorNeutralBackground3Hover: _colors.hcHighlight,
        colorNeutralBackground3Pressed: _colors.hcHighlight,
        colorNeutralBackground3Selected: _colors.hcHighlight,
        colorNeutralBackground4: _colors.hcCanvas,
        colorNeutralBackground4Hover: _colors.hcHighlight,
        colorNeutralBackground4Pressed: _colors.hcHighlight,
        colorNeutralBackground4Selected: _colors.hcHighlight,
        colorNeutralBackground5: _colors.hcCanvas,
        colorNeutralBackground5Hover: _colors.hcHighlight,
        colorNeutralBackground5Pressed: _colors.hcHighlight,
        colorNeutralBackground5Selected: _colors.hcHighlight,
        colorNeutralBackground6: _colors.hcCanvas,
        colorNeutralBackgroundInverted: _colors.hcCanvas,
        colorNeutralBackgroundStatic: _colors.hcCanvas,
        colorNeutralBackgroundAlpha: _colors.hcCanvas,
        colorNeutralBackgroundAlpha2: _colors.hcCanvas,
        colorSubtleBackground: 'transparent',
        colorSubtleBackgroundHover: _colors.hcHighlight,
        colorSubtleBackgroundPressed: _colors.hcHighlight,
        colorSubtleBackgroundSelected: _colors.hcHighlight,
        colorSubtleBackgroundLightAlphaHover: _colors.hcHighlight,
        colorSubtleBackgroundLightAlphaPressed: _colors.hcHighlight,
        colorSubtleBackgroundLightAlphaSelected: _colors.hcHighlight,
        colorSubtleBackgroundInverted: 'transparent',
        colorSubtleBackgroundInvertedHover: _colors.hcHighlight,
        colorSubtleBackgroundInvertedPressed: _colors.hcHighlight,
        colorSubtleBackgroundInvertedSelected: _colors.hcHighlight,
        colorTransparentBackground: 'transparent',
        colorTransparentBackgroundHover: _colors.hcHighlight,
        colorTransparentBackgroundPressed: _colors.hcHighlight,
        colorTransparentBackgroundSelected: _colors.hcHighlight,
        colorNeutralBackgroundDisabled: _colors.hcCanvas,
        colorNeutralBackgroundInvertedDisabled: _colors.hcCanvas,
        colorNeutralStencil1: _colors.hcCanvasText,
        colorNeutralStencil2: _colors.hcCanvasText,
        colorNeutralStencil1Alpha: _colors.hcCanvasText,
        colorNeutralStencil2Alpha: _colors.hcCanvasText,
        colorBackgroundOverlay: _colors.blackAlpha[50],
        colorScrollbarOverlay: _colors.hcButtonFace,
        colorBrandBackground: _colors.hcButtonFace,
        colorBrandBackgroundHover: _colors.hcHighlight,
        colorBrandBackgroundPressed: _colors.hcHighlight,
        colorBrandBackgroundSelected: _colors.hcHighlight,
        colorCompoundBrandBackground: _colors.hcHighlight,
        colorCompoundBrandBackgroundHover: _colors.hcHighlight,
        colorCompoundBrandBackgroundPressed: _colors.hcHighlight,
        colorBrandBackgroundStatic: _colors.hcCanvas,
        colorBrandBackground2: _colors.hcCanvas,
        colorBrandBackground2Hover: _colors.hcCanvas,
        colorBrandBackground2Pressed: _colors.hcCanvas,
        colorBrandBackgroundInverted: _colors.hcButtonFace,
        colorBrandBackgroundInvertedHover: _colors.hcHighlight,
        colorBrandBackgroundInvertedPressed: _colors.hcHighlight,
        colorBrandBackgroundInvertedSelected: _colors.hcHighlight,
        colorNeutralStrokeAccessible: _colors.hcCanvasText,
        colorNeutralStrokeAccessibleHover: _colors.hcHighlight,
        colorNeutralStrokeAccessiblePressed: _colors.hcHighlight,
        colorNeutralStrokeAccessibleSelected: _colors.hcHighlight,
        colorNeutralStroke1: _colors.hcCanvasText,
        colorNeutralStroke1Hover: _colors.hcHighlight,
        colorNeutralStroke1Pressed: _colors.hcHighlight,
        colorNeutralStroke1Selected: _colors.hcHighlight,
        colorNeutralStroke2: _colors.hcCanvasText,
        colorNeutralStroke3: _colors.hcCanvasText,
        colorNeutralStrokeSubtle: _colors.hcCanvasText,
        colorNeutralStrokeOnBrand: _colors.hcCanvas,
        colorNeutralStrokeOnBrand2: _colors.hcCanvasText,
        colorNeutralStrokeOnBrand2Hover: _colors.hcCanvasText,
        colorNeutralStrokeOnBrand2Pressed: _colors.hcCanvasText,
        colorNeutralStrokeOnBrand2Selected: _colors.hcCanvasText,
        colorBrandStroke1: _colors.hcCanvasText,
        colorBrandStroke2: _colors.hcCanvasText,
        colorBrandStroke2Hover: _colors.hcHighlight,
        colorBrandStroke2Pressed: _colors.hcHighlight,
        colorBrandStroke2Contrast: _colors.hcCanvas,
        colorCompoundBrandStroke: _colors.hcHighlight,
        colorCompoundBrandStrokeHover: _colors.hcHighlight,
        colorCompoundBrandStrokePressed: _colors.hcHighlight,
        colorNeutralStrokeDisabled: _colors.hcDisabled,
        colorNeutralStrokeInvertedDisabled: _colors.hcDisabled,
        colorTransparentStroke: _colors.hcCanvasText,
        colorTransparentStrokeInteractive: _colors.hcHighlight,
        colorTransparentStrokeDisabled: _colors.hcDisabled,
        colorNeutralStrokeAlpha: _colors.hcCanvasText,
        colorNeutralStrokeAlpha2: _colors.hcCanvas,
        colorStrokeFocus1: _colors.hcCanvas,
        colorStrokeFocus2: _colors.hcHighlight,
        colorNeutralShadowAmbient: 'rgba(0,0,0,0.24)',
        colorNeutralShadowKey: 'rgba(0,0,0,0.28)',
        colorNeutralShadowAmbientLighter: 'rgba(0,0,0,0.12)',
        colorNeutralShadowKeyLighter: 'rgba(0,0,0,0.14)',
        colorNeutralShadowAmbientDarker: 'rgba(0,0,0,0.40)',
        colorNeutralShadowKeyDarker: 'rgba(0,0,0,0.48)',
        colorBrandShadowAmbient: 'rgba(0,0,0,0.30)',
        colorBrandShadowKey: 'rgba(0,0,0,0.25)'
    });
